import React from "react";

const WhyChoose = ({ title, heading_description, sub_heading }) => {
  // Safely extract sub_heading properties
  const { title: subTitle = "", list = "", image = "" } = sub_heading || {};

  // Convert the bullet point string into an array
  const listItems = list
    ? list.split("\n").filter((item) => item.trim() !== "")
    : [];

  return (
    <div className="py-16 overflow-hidden bg-white sm:py-24">
      <div className="px-6 mx-auto max-w-7xl lg:px-8">
        <div className="grid items-stretch grid-cols-1 gap-x-8 gap-y-16 lg:grid-cols-2">
          {/* Text Content */}
          <div className="flex flex-col items-start justify-center max-w-xl mx-auto text-start lg:mx-0">
            <h2 className="text-3xl font-bold tracking-tight text-purple-900 sm:text-4xl">
              {title}
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              {heading_description}
            </p>

            {subTitle && (
              <p className="mt-8 text-lg font-semibold text-gray-900">
                {subTitle}
              </p>
            )}

            {listItems.length > 0 && (
              <ul className="mt-4 space-y-4">
                {listItems.map((item, index) => (
                  <li key={index} className="flex items-center gap-x-3">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-purple-600/10">
                      <div className="w-2 h-2 bg-orange-600 rounded-full" />
                    </div>
                    <span className="text-base text-gray-600">
                      {item.replace("•", "").trim()}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Image */}
          {image && (
            <div className="relative flex items-stretch justify-center">
              <div className="relative w-full aspect-[4/3] lg:aspect-[3/2] h-full min-h-[400px] lg:min-h-[600px]">
                <img
                  src={image}
                  alt={subTitle || title}
                  className="absolute inset-0 object-cover w-full h-full rounded-2xl bg-gray-50"
                  onError={(e) => {
                    e.target.style.display = "none";
                    console.error("Failed to load why choose us image");
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
